import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { axiosInstance } from "../../auth/Auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function SettingsPassword() {
    const navigate = useNavigate();

    const [resetting, setResetting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");

    const lengthValid = password.length >= 8;
    const uppercaseValid = /[A-Z]/.test(password);
    const lowercaseValid = /[a-z]/.test(password);
    const digitValid = /\d/.test(password);
    const passwordsMatch = password === password2;
    const isValid = lengthValid && uppercaseValid && lowercaseValid && digitValid;

    const handleSubmit = async event => {
        event.preventDefault();
        setResetting(true);

        try {
            await axiosInstance.put("/users/update_password/", {
                old_password: oldPassword,
                new_password_1: password,
                new_password_2: password2,
            });
            toast.success("Your password was reset successfully");
            navigate("/login", { replace: true });
        } catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401) setErrorMessage(error.response.data.detail);
            else setErrorMessage("Unexpected error occured. Please try again later or contact us at tech@radioanalyzer.com");
        }
        setResetting(false);
    };

    return (
        <Row className="flex-grow-1">
            <Col className="bg-white p-4">
                <h2 className="text-center text-lg-start">CHANGE PASSWORD</h2>
                <p className="text-center text-lg-start">All three fields are necessary.</p>
                <Form onSubmit={handleSubmit} className="row" noValidate>
                    <Col xs={12} lg={"auto"}>
                        <Form.Control
                            className="mb-3"
                            value={oldPassword}
                            type="password"
                            placeholder="Old password"
                            name={"old_password"}
                            onChange={e => setOldPassword(e.target.value)}
                        />
                        <Form.Control
                            className="mb-3"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                            name="password"
                            placeholder="New password"
                            isValid={isValid}
                        />
                        <Form.Control
                            className="mb-3"
                            value={password2}
                            onChange={e => setPassword2(e.target.value)}
                            type="password"
                            name="password2"
                            placeholder="Confirm new password"
                            isValid={password && passwordsMatch}
                        />
                        <Col>
                            <ul className="mb-4 text-danger">
                                <li className={lengthValid ? "text-success" : ""}>Must contain at least 8 characters</li>
                                <li className={uppercaseValid ? "text-success" : ""}>Must contain at least 1 uppercase letter</li>
                                <li className={lowercaseValid ? "text-success" : ""}>Must contain at least 1 lowercase letter</li>
                                <li className={digitValid ? "text-success" : ""}>Must contain at least 1 digit</li>
                                <li className={password && passwordsMatch ? "text-success" : ""}>Passwords must match</li>
                            </ul>
                        </Col>
                        {errorMessage && (
                            <Col xs={12} className="mb-2">
                                <span className="text-danger text-uppercase">{errorMessage}</span>
                            </Col>
                        )}
                        <Col xs={12} className="text-center text-lg-start">
                            <Button
                                className={"btn-ra-dark-blue text-light fw-semibold text-uppercase text-center"}
                                type={"submit"}
                                disabled={resetting || !oldPassword || !isValid || !passwordsMatch}>
                                Update new password
                            </Button>
                        </Col>
                    </Col>
                </Form>
            </Col>
        </Row>
    );
}
